import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = ["data-placeholder", "contenteditable"]

import { NodeViewWrapper, NodeViewContent } from '@tiptap/vue-3';
import { ref, onMounted, nextTick, computed } from 'vue';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { Editor } from '@tiptap/core';
import { CalloutTypes } from '@superthread-com/extension-callouts/src/index';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';
import FilterDropdown from '@/components/widgets/filters/FilterDropdown.vue';

/**
 * The correct type definition would be:
 * const props = defineProps<typeof nodeViewProps>();
 *
 * However, that is not supported in Vue 2, so the type must be
 * specified like this.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'Callout',
  props: {
    node: {},
    deleteNode: { type: Function },
    editor: {},
    updateAttributes: { type: Function },
    extension: {}
  },
  setup(__props: any) {

const { iconPath, getCustomIconStyle } = useCustomIcon();
const props = __props;
const { translate } = useTranslate();
const calloutIcons = ref({
  info: 'info',
  success: 'check-square',
  warning: 'alert-triangle',
  error: 'x-octagon',
} as Record<string, string>);

const calloutTranslationKeys = {
  info: 'information',
  success: 'success',
  warning: 'warning',
  error: 'error',
} as Record<string, string>;

const showDropdown = ref(false);
const body = ref(window.document.body);
const filterPopup = ref();

const mentionActive = computed(() => props.editor.extensionStorage.mention.mentionDropdownActive);

onMounted(() => {
  nextTick(() => {
    if (props.editor.isEditable) {
      showDropdown.value = true;
    }
  });
});

const dropdownItems = (Object.keys(CalloutTypes) as Array<keyof typeof CalloutTypes>).map(
  (key: keyof typeof CalloutTypes) => {
    const id = CalloutTypes[key];
    return {
      id: id,
      customIcon: true,
      lighter: true,
      icon: calloutIcons.value[id],
      label: translate(calloutTranslationKeys[id]),
    };
  }
);

const handleOnShow = () => {
  if (!props.editor.isEditable) return false;
  nextTick(() => {
    filterPopup?.value?.searchInput?.focus();
  });
  return true;
};

const handleClick = (item: any, hide: Function) => {
  hide?.();
  props.updateAttributes({ type: item.id });
  props.editor.commands.focus();
};

const handleEsc = (hide: Function) => {
  hide?.();
  props.editor.commands.focus();
};

const handleOnHide = () => {
  props.updateAttributes({ showDropdownOnCreate: false });
};

return (_ctx: any,_cache: any) => {
  const _component_v_popover = _resolveComponent("v-popover")!

  return (_openBlock(), _createBlock(_unref(NodeViewWrapper), {
    "data-block-id": props?.node?.attrs?.['block-id'],
    class: _normalizeClass([props.extension.options.className, "my-2"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["callout", props.node.attrs.type])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_popover, {
            interactive: "",
            tag: "div",
            "content-tag": "div",
            placement: "bottom-start",
            trigger: "click",
            class: "h-6",
            role: 'poper',
            "show-on-create": props.node.attrs.showDropdownOnCreate,
            "append-to": body.value,
            "on-show": handleOnShow,
            "on-hide": handleOnHide
          }, {
            default: _withCtx(({ state }) => [
              _createElementVNode("div", {
                class: _normalizeClass(["callout-icon-wrap", {
                'bg-attention-icon': state.isVisible && props.editor.isEditable,
              }])
              }, [
                _createElementVNode("em", {
                  style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(calloutIcons.value[props.node.attrs.type] || 'info'))),
                  class: "callout-icon custom-icons",
                  contenteditable: "false"
                }, null, 4)
              ], 2)
            ]),
            content: _withCtx(({ state, hide }) => [
              (state.isVisible)
                ? (_openBlock(), _createBlock(FilterDropdown, {
                    key: 0,
                    ref_key: "filterPopup",
                    ref: filterPopup,
                    "search-results": _unref(dropdownItems),
                    "selected-item-check": 
                _unref(dropdownItems).findIndex((item) => item.id === props.node.attrs.type)
              ,
                    "on-item-right-side-click": (item) => handleClick(item, hide),
                    "on-item-click": (item) => handleClick(item, hide),
                    "hide-filter-popup": () => {},
                    placeholder: '',
                    "show-search-input": false,
                    onEsc: ($event: any) => (handleEsc(hide))
                  }, null, 8, ["search-results", "selected-item-check", "on-item-right-side-click", "on-item-click", "onEsc"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show-on-create", "append-to"]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("span", {
            class: _normalizeClass(["callout-content", {
            'suggestion-active': mentionActive.value,
          }]),
            "data-placeholder": _unref(translate)('typeSomething'),
            contenteditable: props.editor.isEditable
          }, [
            _createVNode(_unref(NodeViewContent))
          ], 10, _hoisted_2)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["data-block-id", "class"]))
}
}

})